import { createSelector } from 'reselect';
import { RootState } from '../index';

// Basic selectors
const selectCategoriesState = (state: RootState) => state.categories;

// Memoized selectors for categories
export const selectCategories = createSelector(
  [selectCategoriesState],
  (categoriesState) => categoriesState.categories
);

export const selectCurrentCategory = createSelector(
  [selectCategoriesState],
  (categoriesState) => categoriesState.currentCategory
);

export const selectCurrentImage = createSelector(
  [selectCategoriesState],
  (categoriesState) => categoriesState.currentImage
);

// Helper selector to find a specific image in categories
export const makeSelectImageById = () => 
  createSelector(
    [selectCategories, (_, imageId: string) => imageId],
    (categories, imageId) => {
      for (const category of categories) {
        const image = category.images.find(img => img.id === imageId);
        if (image) return image;
      }
      return null;
    }
  );

// Helper selector to find images in a specific category
export const makeSelectImagesByCategory = () =>
  createSelector(
    [selectCategories, (_, categoryId: string) => categoryId],
    (categories, categoryId) => {
      const category = categories.find(cat => cat.id === categoryId);
      return category ? category.images : [];
    }
  );

// Selector to check if categories are loaded
export const selectAreCategoriesLoaded = createSelector(
  selectCategories,
  (categories) => categories.length > 0
);

// Helper selector to find a specific image in the current category
export const makeSelectImageFromCurrentCategory = () => 
  createSelector(
    [selectCurrentCategory, (_, imageId: string) => imageId],
    (currentCategory, imageId) => {
      if (!currentCategory) {
        return { id: '', name: '', path: '', thumbnail: '', colorScheme: [] } as any;
      }
      
      const image = currentCategory.images.find(img => img.id === imageId);
      return image || { id: '', name: '', path: '', thumbnail: '', colorScheme: [] } as any;
    }
  ); 